import React from "react";

const PostCardSkeleton = () => {
    return (
        <article className="overflow-hidden rounded-lg bg-white dark:bg-slate-850 shadow-sm">
            {/* Image area */}
            <div className="relative overflow-hidden">
                <div className="aspect-[16/10] w-full skeleton-shimmer" />
                {/* Date badge skeleton */}
                <div className="pointer-events-none absolute left-4 top-4 rounded bg-white/80 px-4 py-3 text-center">
                    <div className="mb-1 h-5 w-6 mx-auto rounded skeleton-shimmer" />
                    <div className="h-2.5 w-8 mx-auto rounded skeleton-shimmer" />
                </div>
            </div>

            {/* Content area */}
            <div className="rounded-b-lg p-10">
                {/* Title skeleton - 2 lines */}
                <div className="mb-4 space-y-2">
                    <div className="h-5 w-full rounded skeleton-shimmer" />
                    <div className="h-5 w-3/4 rounded skeleton-shimmer" />
                </div>

                {/* Category skeleton */}
                <div className="mb-5 flex items-center gap-1">
                    <div className="h-4 w-4 rounded skeleton-shimmer" />
                    <div className="h-3 w-16 rounded skeleton-shimmer" />
                    <div className="h-3 w-20 rounded skeleton-shimmer" />
                </div>

                {/* Excerpt skeleton - 3 lines */}
                <div className="space-y-2">
                    <div className="h-4 w-full rounded skeleton-shimmer" />
                    <div className="h-4 w-full rounded skeleton-shimmer" />
                    <div className="h-4 w-2/3 rounded skeleton-shimmer" />
                </div>
            </div>
        </article>
    );
};

export default PostCardSkeleton;
